export const BILLING_HISTORY_QUERY_KEY = 'billingHistory';
export const SUBSCRIPTION_PLANS_QUERY_KEY = 'subscriptionPlans';
export const BUSINESS_SUBSCRIPTION_QUERY_KEY = 'businessSubscription';

export const billingKeys = {
  history: (page?: number) => [BILLING_HISTORY_QUERY_KEY, page] as const,
  plans: (provider?: string) =>
    [SUBSCRIPTION_PLANS_QUERY_KEY, provider] as const,
  business: () => [BUSINESS_SUBSCRIPTION_QUERY_KEY] as const,
};
